<template>
  <div class="info">
    <div style="margin-top: -20px" v-if="projectTabs && projectTabs.length > 1">
      <el-tabs v-model="tabsValue" @tab-click="handleClick">
        <el-tab-pane
          :label="
            (item.projectType === 35 ? '新增 ' : '续约 ') +
            'FW' +
            item.projectNo
          "
          :name="item.projectId"
          v-for="item in projectTabs"
          :key="item.projectId"
        >
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="info-title">
      <h4><i class="iconfont icon-base-info"></i>项目信息</h4>
      <div class="info-title-info">
        <div>客户名称： {{ baseDetailData.customerName }}</div>
        <div>
          商务负责人：
          <!-- <span class="avatar-24" v-if="baseDetailData.salesName"
            ><em>{{ baseDetailData.salesName | simplify }}</em>
          </span> -->
          {{ baseDetailData.salesName }}
        </div>
        <div>
          项目负责人：
          <!-- <span class="avatar-24" v-if="baseDetailData.receiveName"
            ><em>{{ baseDetailData.receiveName | simplify }}</em>
          </span> -->
          {{ baseDetailData.receiveName }}
        </div>
      </div>
      <div style="width: 510px; text-align: right">
        <el-button-group>
          <el-button
            icon="el-icon-suitcase"
            :disabled="baseDetailData.projectSituation !== 0"
            >拜访记录</el-button
          >
          <el-button
            icon="el-icon-shopping-bag-2"
            :disabled="baseDetailData.projectSituation !== 0"
            @click="externalDetail"
            >外采信息</el-button
          >
          <el-button
            icon="el-icon-finished"
            :disabled="baseDetailData.projectSituation !== 0"
            @click="acceptanceDetail"
            >验收管理</el-button
          >
          <el-button
            icon="el-icon-coin"
            :disabled="baseDetailData.projectSituation !== 0"
            @click="costDetail"
            >成本管理</el-button
          >
        </el-button-group>
      </div>
      <div v-if="showCloseButton" class="closePanel" @click="closePanel">
        <i class="el-icon-close"></i>
      </div>
    </div>

    <div class="info-head">
      <div>
        <div class="info-head-base">
          <em
            :class="[
              baseDetailData.projectTypeName === '合同新增B' ? 'new' : 'renewal'
            ]"
            >{{ handleTag(baseDetailData.projectTypeName) }}</em
          >
          <el-tooltip
            class="item"
            effect="dark"
            content="跳转到项目"
            placement="top"
            v-if="showCloseButton"
          >
            <el-button
              icon="el-icon-connection"
              size="mini"
              circle
              style="margin-right: 10px"
              @click="jumpToProject"
            ></el-button>
          </el-tooltip>

          <h5>FW{{ baseDetailData.projectNo }}</h5>

          <span
            >{{ baseDetailData.projectTotalName }}
            <span
              class="project-status"
              v-if="baseDetailData.mainLifeCycle === 3"
            >
              {{ baseDetailData.mainLifeCycle === 3 ? "提前启动" : "" }}
              <!-- {{
                baseDetailData.MainLifeCycle === 1
                  ? "正式实施"
                  : baseDetailData.mainLifeCycle === 2
                  ? "实施完毕"
                  : baseDetailData.mainLifeCycle === 3
                  ? "提前启动"
                  : "售后"
              }} -->
            </span>
            <span
              class="project-status"
              v-if="
                baseDetailData.minorLifeCycle === 1 ||
                baseDetailData.minorLifeCycle === 2 ||
                baseDetailData.minorLifeCycle === 4
              "
            >
              {{
                baseDetailData.minorLifeCycle === 1
                  ? "正式实施"
                  : baseDetailData.mainLifeCycle === 2
                  ? "实施完毕"
                  : baseDetailData.mainLifeCycle === 4
                  ? "售后"
                  : ""
              }}
            </span>
            <em v-if="baseDetailData.projectSituation !== 0">{{
              baseDetailData.projectSituation !== 0 ? "放弃项目" : ""
            }}</em></span
          >
        </div>
        <div class="info-head-tag">
          <el-tag>{{ baseDetailData.regionalName }}</el-tag>
          <el-tag>{{ baseDetailData.marketTypeName }}</el-tag>
          <!-- <el-tag type="danger">服务期：2022-07-01 至 2022-12-31</el-tag> -->
        </div>
      </div>

      <div style="text-align: center">
        <div class="fn-amount">
          <em>实际</em
          ><span class="amount">{{
            baseDetailData.actualAmount | priceFilter
          }}</span
          >元
        </div>

        <el-tag type="success">
          <span v-if="baseDetailData.proceedsDate !== '1900-01-01 00:00:00'">
            合同归档日期：{{ baseDetailData.proceedsDate | TimeFilter }}</span
          >
          <span v-else>暂无归档日期</span>
        </el-tag>
      </div>
    </div>
    <!--unfold  collapse -->
    <div :class="isShow && !showCloseButton ? 'collapse' : 'unfold'">
      <el-row :gutter="15">
        <el-col :span="18">
          <el-row :gutter="15">
            <el-col :span="24">
              <div class="grid-content grid-1">
                <h5>基本信息</h5>
                <el-descriptions :column="3" size="large">
                  <!-- <el-descriptions-item label="客户名称">
                    {{ baseDetailData.customerName }}
                  </el-descriptions-item>
                  <el-descriptions-item label="商务负责人"
                    ><span class="avatar-24" v-if="baseDetailData.salesName"
                      ><em>{{ baseDetailData.salesName | simplify }}</em></span
                    >{{ baseDetailData.salesName }}</el-descriptions-item
                  > -->
                  <el-descriptions-item label="中标通知书">
                    <div
                      v-if="baseDetailData.noticeOfAwardManagementList.length"
                    >
                      <span
                        v-for="(
                          item, index
                        ) in baseDetailData.noticeOfAwardManagementList"
                        :key="index"
                        style="margin-right: 5px"
                      >
                        <a :href="item.damFilePath">附件{{ index + 1 }}</a>
                        <!-- <a :href="item.damFilePath">{{
                        item.damFilePath | fileNameReduce
                      }}</a> -->
                      </span>
                    </div>
                    <div v-else>暂无附件</div>
                  </el-descriptions-item>
                  <el-descriptions-item
                    label="项目描述"
                    content-class-name="my-content"
                  >
                    暂无项目描述
                  </el-descriptions-item>
                </el-descriptions>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="12">
              <div class="grid-content grid-2">
                <h5>合同信息</h5>
                <div
                  class="contractSwitch"
                  v-if="baseDetailData.contractManagementList.length > 1"
                >
                  <div
                    v-for="(
                      item, index
                    ) in baseDetailData.contractManagementList"
                    :key="index"
                    :class="{ active: index === activeIndex }"
                  >
                    <span @click="contractCurrent(index)"
                      >合同{{ index + 1 }}</span
                    >
                  </div>
                </div>

                <el-descriptions
                  :column="2"
                  size="large"
                  v-if="baseDetailData.contractManagementList.length"
                >
                  <el-descriptions-item label="合同名称" :span="2">
                    <span v-if="baseDetailData.contractManagementList.length">
                      {{
                        baseDetailData.contractManagementList[
                          contractCurrentVal
                        ].contractName
                      }}
                    </span>
                    <span v-else>暂无</span>
                  </el-descriptions-item>

                  <el-descriptions-item label="实际归档" :span="2">
                    <span
                      v-if="
                        baseDetailData.contractManagementList[
                          contractCurrentVal
                        ].archiveDate === '1900-01-01 00:00:00'
                      "
                    >
                      暂无
                    </span>
                    <span v-else>
                      {{
                        baseDetailData.contractManagementList[
                          contractCurrentVal
                        ].archiveDate | TimeFilter
                      }}</span
                    >
                  </el-descriptions-item>
                  <el-descriptions-item
                    label="合同附件"
                    content-class-name="my-content"
                  >
                    <span
                      v-if="
                        baseDetailData.contractManagementList[
                          contractCurrentVal
                        ].damFilePath
                      "
                    >
                      <a
                        :href="
                          baseDetailData.contractManagementList[
                            contractCurrentVal
                          ].damFilePath
                        "
                      >
                        {{
                          baseDetailData.contractManagementList[
                            contractCurrentVal
                          ].damFilePath | fileNameReduce
                        }}
                      </a>
                    </span>
                    <span v-else>暂无</span>
                  </el-descriptions-item>
                </el-descriptions>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content grid-3">
                <h5>验收信息</h5>
                <div
                  class="contractSwitch"
                  v-if="baseDetailData.acceptanceCheckManagementList.length > 1"
                >
                  <div
                    v-for="(
                      item, index
                    ) in baseDetailData.acceptanceCheckManagementList"
                    :key="index"
                    :class="{ active: index === activeCheckIndex }"
                  >
                    <span @click="acceptanceCheck(index)"
                      >验收{{ index + 1 }}</span
                    >
                  </div>
                </div>

                <el-descriptions
                  :column="2"
                  size="large"
                  v-if="baseDetailData.acceptanceCheckManagementList.length"
                >
                  <el-descriptions-item label="发起时间">
                    <span
                      v-if="
                        baseDetailData.acceptanceCheckManagementList[
                          acceptanceCheckVal
                        ].initiateDate
                      "
                    >
                      {{
                        baseDetailData.acceptanceCheckManagementList[
                          acceptanceCheckVal
                        ].initiateDate | TimeFilter
                      }}
                    </span>
                    <span v-else>暂无</span>
                  </el-descriptions-item>
                  <el-descriptions-item label="验收时间">
                    <span
                      v-if="
                        baseDetailData.acceptanceCheckManagementList[
                          acceptanceCheckVal
                        ].confirmDate === '1900-01-01 00:00:00'
                      "
                      >暂无
                    </span>
                    <span v-else>
                      {{
                        baseDetailData.acceptanceCheckManagementList[
                          acceptanceCheckVal
                        ].confirmDate | TimeFilter
                      }}
                    </span>
                  </el-descriptions-item>
                  <el-descriptions-item label="申请报告" :span="2">
                    <span
                      v-if="
                        baseDetailData.acceptanceCheckManagementList[
                          acceptanceCheckVal
                        ].damAcceptanceFilePath
                      "
                    >
                      <a
                        :href="
                          baseDetailData.acceptanceCheckManagementList[
                            acceptanceCheckVal
                          ].damAcceptanceFilePath
                        "
                      >
                        {{
                          baseDetailData.acceptanceCheckManagementList[
                            acceptanceCheckVal
                          ].damAcceptanceFilePath | fileNameReduce
                        }}
                      </a>
                    </span>
                    <span v-else>暂无</span>
                  </el-descriptions-item>
                  <el-descriptions-item
                    label="验收单"
                    :span="2"
                    content-class-name="my-content"
                  >
                    <span
                      v-if="
                        baseDetailData.acceptanceCheckManagementList[0]
                          .damConfirmFilePath
                      "
                    >
                      <a
                        :href="
                          baseDetailData.acceptanceCheckManagementList[0]
                            .damConfirmFilePath
                        "
                      >
                        {{
                          baseDetailData.acceptanceCheckManagementList[0]
                            .damConfirmFilePath | fileNameReduce
                        }}
                      </a>
                    </span>
                    <span v-else>暂无</span>
                  </el-descriptions-item>
                </el-descriptions>
              </div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="6">
          <div class="grid-content grid-4">
            <h5>回款信息</h5>
            <div style="margin-top: 25px" v-if="activities">
              <el-scrollbar ref="hotScroll" style="height: 250px">
                <el-timeline :reverse="false">
                  <el-timeline-item
                    v-for="(activity, index) in activities"
                    :key="index"
                    :icon="activity.icon"
                    :type="activity.type"
                    :color="activity.color"
                    :size="activity.size"
                    :timestamp="activity.proceedsDate | TimeFilter"
                  >
                    <span v-if="activity.projectType">
                      {{ handleYear(activity.projectType) }}
                    </span>
                    <em>{{ activity.actualAmount | priceFilter }}</em> 元
                  </el-timeline-item>
                </el-timeline>
              </el-scrollbar>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="btn" v-if="!showCloseButton">
        <el-button type="text" @click="switchPanel">
          {{ isShow ? "展开面板" : "收起面板" }}
          <i
            class="iconfont"
            :class="isShow ? 'icon-double-down' : 'icon-double-up'"
          ></i>
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { HandoverProject } from "@/api/index.js";

export default {
  props: [
    "showCloseButton",
    "baseDetailData",
    "projectTabsValue",
    "projectTabs"
  ],
  data() {
    return {
      activeIndex: 0,
      activeCheckIndex: 0,
      contractCurrentVal: 0, // 合同信息默认第一个
      acceptanceCheckVal: 0, // 验收信息默认第一个
      activities: [],
      dialogVisible: false,
      reminderForm: {
        businessClass: [],
        expireDate: "",
        delayDate: "",
        mailbox: "",
        active: 0
      },
      rules: {
        businessClass: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个业务类型",
            trigger: "change"
          }
        ],
        expireDate: [
          { required: true, message: "请选择到期时间", trigger: "change" }
        ]
        // delayDate: [
        //   { required: true, message: "请选择延期时间", trigger: "change" }
        // ]
      },
      newCostCreateBtn: true,
      businessClassId: "",
      loading: true,

      isShow: true,

      tabsValue: "",

      dialogHandover: false, // 项目移交弹窗
      formInline: {
        ProjectId: "",
        ReceiveUserGUID: ""
      },
      options: []
    };
  },
  activated() {},
  watch: {
    baseDetailData(newVal, oldVal) {
      this.refundProjectTaskList(); // 回款数据
      if (newVal.projectTotalId === oldVal.projectTotalId) {
      } else {
        this.tabsValue = this.projectTabsValue.toString();
      }
    }
  },
  computed: {},
  created() {},
  mounted() {
    this.refundProjectTaskList(); // 回款数据
    this.tabsValue = this.projectTabsValue.toString();
  },
  methods: {
    jumpToProject() {
      // console.log(this.baseDetailData);
      const routeUrl = this.$router.resolve({
        path: "/project/project-detail",
        query: {
          projectTotalId: this.baseDetailData.projectTotalId,
          projectId: this.baseDetailData.projectId,
          projectNo: this.baseDetailData.projectNo
        }
      });
      window.open(routeUrl.href, "_blank");
    },
    closePanel() {
      this.$emit("closePanel", false);
    },
    refundProjectTaskList() {
      let data = this.baseDetailData.refundProjectTaskList;
      data.map((item) => {
        item.color = "#0bbd87";
        // console.log("item.proceedsDate", item.proceedsDate);
        if (
          item.proceedsDate === "1900-01-01 00:00:00" &&
          item.actualAmount === 0
        ) {
          item.actualAmount = item.budget;
          item.proceedsDate = item.dealDate;
          item.color = "#e4e7ed";
        }
      });
      data.sort((a, b) => new Date(a.proceedsDate) - new Date(b.proceedsDate));
      this.activities = data;
      // console.log("activities", this.activities);
    },

    handleTag(str) {
      if (str === "合同新增B") {
        return "新增";
      } else {
        return "续约";
      }
    },

    handleYear(str) {
      if (str === 37) {
        return "回款当年B：";
      } else {
        return "回款历年A：";
      }
    },

    contractCurrent(val) {
      this.contractCurrentVal = val;
      this.activeIndex = val;
    },
    acceptanceCheck(val) {
      this.acceptanceCheckVal = val;
      this.activeCheckIndex = val;
    },

    // 跳转外部合同页面
    externalDetail() {
      const routeUrl = this.$router.resolve({
        path: "/external",
        query: {
          ProjectId: this.baseDetailData.projectId,
          ProjectNo: this.baseDetailData.projectNo
        }
      });
      window.open(routeUrl.href, "_blank");
    },

    // 跳转验收页面
    acceptanceDetail() {
      const routeUrl = this.$router.resolve({
        path: "/acceptance",
        query: {
          ProjectId: this.baseDetailData.projectId,
          ProjectNo: this.baseDetailData.projectNo
        }
      });
      window.open(routeUrl.href, "_blank");
    },

    // 成本管理
    costDetail() {
      const routeUrl = this.$router.resolve({
        path: "/cost",
        query: {
          ProjectId: this.baseDetailData.projectId,
          ProjectNo: this.baseDetailData.projectNo
        }
      });
      window.open(routeUrl.href, "_blank");
    },
    checkedChangeId(value) {
      // console.log(value);
      this.businessClassId = value.filter((item) => !isNaN(item)).join(",");
      // console.log(this.businessClassId);
    },
    switchPanel() {
      this.isShow = !this.isShow;
      // console.log(this.isShow);
    },
    // tabs 切换
    handleClick(tab, event) {
      // console.log(tab, event);
      this.$emit("tabsProjectNo", tab.name);
    },
    changeValue(val) {
      this.formInline.ReceiveUserGUID = val;
    },

    ConfirmHandover() {
      let params = {
        ProjectId: this.baseDetailData.projectId,
        ReceiveUserGUID: this.formInline.ReceiveUserGUID
      };
      HandoverProject(params)
        .then((res) => {
          this.$message({
            message: "该项目已移交",
            type: "success"
          });
          // 返回一条记录，与 router.back() 相同
          this.$router.go(-1);
        })
        .catch((err) => {
          console.warn(err);
        })
        .finally(() => {
          this.dialogHandover = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.icon-base-info {
  font-weight: 400;
  margin-right: 10px;
  color: var(--brand);
}

.info {
  background: linear-gradient(
    0deg,
    rgba(230, 253, 255, 0) 40%,
    rgba(230, 240, 255, 0.6) 100%
  );
  // height: 510px;
  padding: 20px;
  // border-bottom: 1px solid var(--color-border);
  a {
    color: var(--brand);
    &:hover {
      color: var(--text-link);
      text-decoration: underline;
    }
  }
}
.info-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .info-title-info {
    flex: 1;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: var(--text-1);
    font-size: 14px;
    margin-left: 40px;
    > div {
      margin-right: 40px;
    }
  }
}
.info-head {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  margin-top: 10px;
  .info-head-base {
    font-size: 18px;
    font-weight: 500;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 8px 0;
    span {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .new {
      background-color: #67c23a;
      &::before {
        content: "";
        font-size: 16px;

        width: 10px;
        height: 20px;
        position: absolute;
        background: #67c23a;
        border-radius: 2px;
        left: -5px;
        transform: skewX(-15deg);
      }
      &::after {
        content: "";
        font-size: 16px;
        width: 10px;
        height: 20px;
        position: absolute;
        background: #67c23a;
        border-radius: 2px;
        right: -5px;
        transform: skewX(-15deg);
      }
    }
    .renewal {
      background-color: #fa8101;
      &::before {
        content: "";
        width: 10px;
        height: 20px;
        position: absolute;
        background: #fa8101;
        border-radius: 2px;
        left: -5px;
        transform: skewX(-15deg);
      }
      &::after {
        content: "";
        width: 10px;
        height: 20px;
        position: absolute;
        background: #fa8101;
        border-radius: 2px;
        right: -5px;
        transform: skewX(-15deg);
      }
    }
    em {
      width: 42px;
      color: #fff;
      padding: 0 6px;
      font-style: normal;
      font-size: 14px;
      position: relative;
      margin-left: 8px;
      margin-right: 20px;
      text-align: center;
    }
    h5 {
      font-size: 18px;
      color: var(--text-3);
      padding-right: 15px;
      margin-right: 15px;
      position: relative;
      &:after {
        content: "|";
        position: absolute;
        right: 0;
      }
    }
    span {
      flex: 1;
      padding-right: 30px;
      em {
        width: auto;
        color: var(--error-color);
        font-size: 12px;
        border: 1px solid var(--error-color);
        border-radius: 2px;
        display: inline-block;
        white-space: nowrap;
      }
    }
  }
  .info-head-tag {
    .el-tag {
      margin-right: 5px;
    }
  }
}
.fn-amount {
  text-align: center;
  em {
    font-style: normal;
    font-size: 12px;
  }
  .amount {
    color: var(--text-1);
    // color: var(--success-color);
    font-size: 34px;
    font-weight: 500;
    font-family: "DIN Alternate", -apple-system, "PingFang SC", Microsoft YaHei,
      Segoe UI, Rototo, Helvetica, Arial, sans-serif;
    padding: 0 5px;
  }
}

.grid-content {
  height: 5px;
  font-size: 14px;
  height: 150px;
  border-radius: 4px;
  // box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.04);
  padding: 20px;
  position: relative;
  h5 {
    font-size: 14px;
    font-weight: 400;
    padding: 4px 10px;
    position: absolute;
    top: 0;
    left: 0;
    border-top-left-radius: 4px;
    border-bottom-right-radius: 10px;
  }
}
.grid-1 {
  // background: url("~@/assets/pic-grid-1.svg") no-repeat right bottom,
  //   linear-gradient(180deg, #f1fbff 20%, #fff);
  background: url("~@/assets/pic-grid-bg1.svg") no-repeat right bottom,
    linear-gradient(
      -180deg,
      rgba(217, 236, 255, 0.3) 0%,
      rgba(204, 230, 255, 0.2) 100%
    );
  margin-bottom: 15px;
  transition: all 0.3s ease;
  h5 {
    color: var(--brand);
    background: #dbf3ff;
  }
}
.grid-2 {
  background: url("~@/assets/pic-grid-bg2.svg") no-repeat right bottom,
    linear-gradient(180deg, #f4f5ff 20%, #f4f5ff);
  h5 {
    color: #7d4dff;
    background: #dfdffd;
  }
}
.grid-3 {
  background: url("~@/assets/pic-grid-bg3.svg") no-repeat right bottom,
    linear-gradient(180deg, #fffbf3 20%, #fffbf3);
  h5 {
    color: #fa8101;
    background: #ffedcb;
  }
}
.grid-4 {
  height: 315px;
  background: url("~@/assets/pic-grid-bg4.svg") no-repeat right bottom,
    linear-gradient(180deg, #f9fff6 40%, #f9fff6);
  h5 {
    color: #52c41a;
    background: #ddf3c7;
  }
  em {
    font-size: 16px;
    font-style: normal;
    font-family: "DIN Alternate", -apple-system, "PingFang SC", Microsoft YaHei,
      Segoe UI, Rototo, Helvetica, Arial, sans-serif;
  }
}
::v-deep .el-descriptions__body {
  background: none;
  font-size: 14px !important;
  margin-top: 25px;
}
.closePanel {
  // right: 20px;
  // top: 18px;
  font-size: 18px;
  color: var(--text-1);
  margin-left: 20px;
  cursor: pointer;
  &:hover {
    color: var(--text-link);
  }
}
.contractSwitch {
  position: absolute;
  right: 20px;
  top: 5px;
  font-size: 12px;
  display: flex;
  justify-content: flex-start;
  > div {
    margin-left: 10px;
    cursor: pointer;
    color: var(--text-2);
    display: block;
    background-color: #fff;
    padding: 2px 4px;
    border-radius: 2px;

    &:hover {
      color: #fff;
      background-color: var(--brand);
    }
  }
}
.active {
  color: #fff !important;
  background-color: var(--brand) !important;
}
.el-timeline {
  margin-left: 5px;
}
.unfold {
  position: relative;
  padding-top: 5px;
  .btn {
    position: absolute;
    bottom: 5px;
    z-index: 1;
    left: 50%;
    transform: translateX(-50%);
    .iconfont {
      font-size: 12px;
    }
  }
}
.collapse {
  height: 46px;
  overflow: hidden;
  position: relative;
  padding-top: 5px;
  &:after {
    content: "";
    width: 100%;
    height: 64px;
    background: linear-gradient(to top, #fff, #ffffff00);
    position: absolute;
    bottom: 0;
  }
  .btn {
    position: absolute;
    bottom: 0;
    z-index: 1;
    left: 50%;
    transform: translateX(-50%);
    .iconfont {
      font-size: 12px;
    }
  }
}
.icon-efferent {
  font-size: 12px;
  margin-right: 5px;
}
.project-status {
  font-size: 12px;
  font-weight: normal;
  color: var(--brand);
  background: #e6f7ff;
  margin-left: 10px;
  margin-right: 30px;
  border-radius: 2px;
  padding: 2px 8px !important;
}

.avatar-24 {
  width: 26px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  display: inline-block;
  border-radius: 26px;
  color: var(--brand);
  background-color: #e6f7ff;
  margin-right: 5px;
  em {
    font-size: 12px;
    font-style: normal;
    display: block;
    transform: scale(0.8);
    transform-origin: center center;
  }
}
</style>
